import styled from 'styled-components';
import { color, bp, ease } from '../../styles/tokens';

export const Rules = styled.ul`
  display: grid;
  gap: 14px;

  ${bp.sm} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${bp.lg} {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  li {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 24px;
    border: 1px solid ${color.lineDark};
    border-radius: 14px;
    background: ${color.inkSoft};
    transition: border-color 0.4s ${ease};

    &:hover {
      border-color: ${color.rose};
    }
  }

  .icon {
    flex: none;
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    color: ${color.rose};

    svg {
      width: 100%;
      height: auto;
    }
  }

  p {
    font-size: 14.5px;
    line-height: 1.55;
    color: rgba(240, 220, 222, 0.78);

    b {
      font-weight: 500;
      color: ${color.white};
    }
  }
`;
